import { icons } from "constants/icons";
import cn from "classnames";
import { SortDirection } from "types/common";

type Props = {
  handleClick: any;
  item: any;
  sortConfig: any;
};

export const TableHeaderButton = ({ handleClick, item, sortConfig }: Props) => {
  return (
    <button
      type="button"
      onClick={item.sortBy ? handleClick : null}
      className=" flex items-center space-x-2"
    >
      <strong>{item.title}</strong>
      {item.sortBy && (
        <img
          src={
            sortConfig.sortBy !== item.sortBy
              ? icons.carrotDown
              : sortConfig.sortDirection === SortDirection.desc
              ? icons.carrotDownGreen
              : icons.carrotDownRed
          }
          alt="arrow"
          className={cn("transition-all mt-[0.5px]", {
            "rotate-180":
              sortConfig.sortBy === item.sortBy &&
              sortConfig.sortDirection === SortDirection.asc,
          })}
        />
      )}
    </button>
  );
};
